























































































































import {Vue, Component, Prop} from "vue-property-decorator";
import {ParticipantsDataHelper} from "@mixins/ParticipantsDataHelper";
import {UserProfile} from "@api/models/UserProfile";
import { EventMembershipTypes } from '@api/enums/EventMembershipTypes';
import ParticipantTable from "./components/ParticipantTable.vue";
import { ColumnFieldInterface } from "@mixins/models/ColumnFieldInterface"
import {Debounce} from "vue-debounce-decorator";
import {ParticipantBusynessHelper} from "@mixins/ParticipantBusynessHelper";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import {MeetingRepository} from "@api/repositories/MeetingRepository";
import {DateTime} from "luxon";
import {EventBus} from "@common/EventBus";
import {detectMob} from "@common/mobileHelper";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import {IsMeetingsEnabled} from "@mixins/isMeetingsEnabled";
import Spinner from '@service/components/Spinner.vue';

import TableSearch from "@share/common/table-search/TableSearch.vue";
import TagList from "@share/common/tag-list/TagList.vue";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import FilterModal from "./components/FilterModal.vue";
import ControlWrapper from "@share/common/ControlWrapper.vue";
import {isBottom as isBottomFn} from "@common/isBottom";
import { ParticipantsTagsHelper } from "./helpers/ParticipantsTagsHelper"

import { TagsHelper } from "@common/TagsHelper"
import { SelectableTag } from "@api/models/SelectableTag";
import {ParticipantsFiltersAvailability} from "@share/participants-table/types/ParticipantsFiltersAvailability";
import {filtersAvailabilityDefaultValue} from "@share/participants-table/helpers/FiltersHelper";
import { DynamicScroller, DynamicScrollerItem, RecycleScroller } from 'vue-virtual-scroller'
import TableArrows from "@share/common/table-arrows/TableArrows.vue";
import AdminPanel from "@share/common/admin-panel/AdminPanel.vue";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import UserCreate from "@share/participants-table/components/admin/UserCreate.vue"
import { deepCopy } from "@common/ObjectsHelper";

@Component({
    name: 'ParticipantsTable',
    components: { UserCreate, AdminPanel, TableArrows, ControlWrapper, FilterModal, TableSearch, BounceSpinner, ParticipantTable, Spinner, TagList, DynamicScroller, DynamicScrollerItem }
})
export default class ParticipantsTable extends IsMeetingsEnabled {
    @Prop({required: true}) dataHelper: ParticipantsDataHelper;
    @Prop({
        required: false,
        default: () => [{ fieldName: "company" }]
    }) fields: ColumnFieldInterface[];
    @Prop({default:  filtersAvailabilityDefaultValue}) filtersAvailability: ParticipantsFiltersAvailability | null;

    showUserCreate = false;

    selected: UserProfile | null = null;
    selectedUserId: number | null = null;
    userIdForEdit?: number | null = null;

    itemComponent = ParticipantTable;

    showSearch = true;
    searchPlaceholder = "";
    busynessHelper: ParticipantBusynessHelper | null = null;

    currentFilter = "company";
    currentFilterIndex =  0;
    isFilterReversed = false;

    isAllFilterShowed = false;
    tagsForModal: SelectableTag[] = []

    objectRepository: ObjectRepository;

    isFiltersModalVisible = false;

    selectedTagIds: string[] = [];

    tagsHelper: ParticipantsTagsHelper | null = null;

    loaded = false;

    created() {
        this.objectRepository = this.$repositories.get(RepositoryFabric.OBJECT);
        this.dataHelper.onlineOnly = this.$route.params.onlineOnly === "true";
        this.tagsHelper = new ParticipantsTagsHelper(this.objectRepository, this.$store);
    }

    close() {
        this.$router.back()
    }

    onSelectTag(eventItem: SelectableTag) {
        TagsHelper.switchSelection(this.dataHelper.tags, eventItem);
        TagsHelper.saveToLocalStorage(this.dataHelper.tags, this.lsKey);
        this.dataHelper.page = 1;
        this.dataHelper.fetchUsers();
    }

    applyFilters() {

        this.dataHelper.tags.forEach(item => {
            if (this.selectedTagIds.indexOf(item.tag.id) >= 0) {
                item.isSelected = true;
            } else {
                item.isSelected = false;
            }
        });

        this.isFiltersModalVisible = false;
        this.selectedTagIds = [];

        TagsHelper.saveToLocalStorage(this.dataHelper.tags, this.lsKey);
        this.dataHelper.page = 1;
        this.dataHelper.fetchUsers();
    }

    resetFilters() {
        this.dataHelper.tags.forEach(item => item.isSelected = false);
        TagsHelper.saveToLocalStorage(this.dataHelper.tags, this.lsKey);
        this.isFiltersModalVisible = false;
        this.dataHelper.fetchUsers();
    }

    accumulateFilters(tagWrapper: SelectableTag) {
        if (!tagWrapper.isSelected) {
            this.selectedTagIds.push(tagWrapper.tag.id);
        } else {
            this.selectedTagIds = this.selectedTagIds.filter(id => id !== tagWrapper.tag.id);
        }

        TagsHelper.switchSelection(this.tagsForModal, tagWrapper);
    }

    setSelectedTags() {
        const ids = TagsHelper.getTagsIdsFromLocalStorage(this.lsKey)
        if (!ids) {
            return;
        }

        this.dataHelper.tags.forEach(item => {
            if (ids.indexOf(item.tag.id) >= 0) {
                item.isSelected = true;
            }
        });
    }

    showFiltersModal() {
        this.selectedTagIds = [];

        this.tagsForModal = this.dataHelper.tags.map(item => {
            if (item.isSelected) {
                this.selectedTagIds.push(item.tag.id);
            }
            return { tag: item.tag, isSelected: item.isSelected }
        });

        this.isFiltersModalVisible = true;
    }

    goToParticipantsImport() {
        if(this.isOnEditing) {
            this.$router.push({
                name: RouteNamesEnum.participantsImport,
                params: {
                    eventId: this.$route.params.eventId,
                    backend: this.$route.params.backend
                }
            })
        }
    }

    updateEditedProfile(editedUserProfile: UserProfile) {
        for (let [index, iterator] of this.list.entries()) {
            if(iterator.userId === editedUserProfile.userId) {
                Vue.set(this.list, index, new UserProfile(deepCopy(editedUserProfile)))
                break;
            }
        }
    }

    openCreateUserForm() {
        this.showUserCreate = true;
        if(this.userIdForEdit) {
            this.userIdForEdit = null;
        }
    }

    openEditUserForm(profile: UserProfile) {
        this.showUserCreate = true;
        this.userIdForEdit = profile.userId;
    }

    closeShowUserCreate() {
        this.showUserCreate = false;
    }

    get searchPanelTags() {
        return this.dataHelper?.tags.filter(tag => this.tagsHelper?.parentTags[0]?.id === tag.tag.parentId) ?? []
    }

    get maxTagsToShow() {
        return window.innerWidth < 1024 ? 0 : 5;
    }

    get lsKey() {
        return this.backend + this.$store.getters.userId + '_participants-filter';
    }

    get isFilterSet() {
        return this.dataHelper.tags.some(item => item.isSelected);
    }

    get list() {
        return this.dataHelper?.list || [];
    }

    get showParticipant() {
        return this.selected || this.selectedUserId;
    }

    get backend() {
        return this.$store.state.session.backend;
    }

    get today() {
        return DateTime.local();
    }

    get busyness() {
        return this.busynessHelper?.list || [];
    }

    get groupFilter() {
        return this.$store.getters.groupFilter || {};
    }

    get showComponentSpinner() {
        return this.dataHelper.isLoading && this.dataHelper.page === 1;
    }

    get showListSpinner() {
        return this.dataHelper.isLoading && this.dataHelper.page > 1;
    }

    get isOnEditing() {
        return this.$store.state.isOnEditing;
    }

    getPlaceholderText() {
        return detectMob() ? this.$t('common.search') : this.$t('participants.search')
    }

    getFieldTitle(field: ColumnFieldInterface) {
        if(field.label) {
            return field.label[this.$store.state.session.language] || field.label['en'] || field.label[Object.keys(field.label)[0]] || ""
        } else {
            return this.$t('participants.' + field.fieldName)
        }
    }

    async mounted() {
        this.currentFilter = this.dataHelper.filterOrder;
        this.busynessHelper = Vue.observable(new ParticipantBusynessHelper(this.$repositories.get(RepositoryFabric.MEETING) as MeetingRepository, this.backend, this.$store));

        this.$refs['list'] && ((this.$refs['list'] as any).$el as HTMLElement).addEventListener('scroll', this.userScrollHandler);
        window.addEventListener('resize', this.resizeHandler);
        this.searchPlaceholder = this.getPlaceholderText() as string;

        await this.getTags();
        this.setSelectedTags();
        await this.dataHelper.fetchUsers();
        this.loaded = true;

        // remove 'hoverKey' prop for preventing add or remove hover class
        delete ((this.$refs.list as typeof DynamicScroller | undefined)?.$refs.scroller as typeof RecycleScroller | undefined)?.$data.hoverKey;
    }

    activated() {
        this.setOnlyOnline();
    }

    setOnlyOnline() {
        const onlineOnly = this.$route.params.onlineOnly === "true";
        if(onlineOnly !== this.dataHelper.onlineOnly) {
            this.dataHelper.onlineOnly = onlineOnly;
            this.toggleOnlineFilter(onlineOnly)
        }
    }

    async getTags() {

        await this.tagsHelper?.loadTags();

        this.dataHelper.tags = this.tagsHelper?.tags.map(tag => {
            return { tag: Object.freeze(tag), isSelected: false }
        }) ?? [];
    }

    toggleFilter(fieldName: string, index = 0) {
        if(this.dataHelper.searchStr) {
            return;
        }
        const sanitizedFieldName = fieldName[0].toLowerCase() + fieldName.slice(1);
        if(this.currentFilter === fieldName) {
            this.isFilterReversed = !this.isFilterReversed;
        } else {
            this.currentFilterIndex = index;
            this.isFilterReversed = false;
            this.currentFilter = fieldName;

        }
        this.dataHelper.filterOrder = sanitizedFieldName;
        this.dataHelper.filterDirection = this.isFilterReversed ? "desc" : "asc"
        this.dataHelper.page = 1;

        this.dataHelper.sortOnClient ? this.dataHelper.sortList() : this.dataHelper.fetchUsers();
    }

    select(participant: UserProfile, emit = true) {
        emit && this.$emit('select', participant.userId);
        this.$set(this, 'selected', participant as UserProfile);
        this.selectedUserId = null;
        this.busynessHelper?.setUserId(participant.userId as number);
        if (detectMob()) {
            this.$disableBodyScroll(this.$refs['content'] as HTMLElement);
        }
    }

    @Debounce(500)
    onSearchInput() {
        this.dataHelper.page = 1;
        this.dataHelper.fetchUsers();
        this.$nextTick(() => {
            (this.$refs['list'] as any).scrollToItem(0);
        })
    }

    clearInput() {
        this.dataHelper.searchStr = "";
        this.onSearchInput();
    }

    @Debounce(200)
    resizeHandler() {
        if (this.$route.meta?.participants) {
            this.searchPlaceholder = this.getPlaceholderText() as string;
            if (!detectMob()) {
                this.$clearAllBodyScrollLocks();
            }
        }
    }

    @Debounce(300)
    userScrollHandler() {
        if (!this.dataHelper.isLoading && this.dataHelper.count > this.dataHelper.list.length) {

            const isBottom = isBottomFn((this.$refs['list'] as any).$el)
            if (isBottom) {
                this.dataHelper.page++;
                this.dataHelper.fetchUsers();
            }
        }
    }

    toggleOnlineFilter(value: boolean) {
        this.dataHelper.onlineOnly = value;
        this.toggleUserPropertyFilter();
    }

    toggleOnlySpeakersFilter(value: boolean) {
        this.dataHelper.participantTypes = value ? [EventMembershipTypes.speaker] : [EventMembershipTypes.speaker, EventMembershipTypes.participant];
        this.toggleUserPropertyFilter();
    }

    toggleRecommendedFilter(value: boolean) {
        this.dataHelper.recommendedOnly = value;
        this.toggleUserPropertyFilter();
    }

    @Debounce(500)
    toggleUserPropertyFilter() {
        this.dataHelper.page = 1;
        this.dataHelper.fetchUsers();
    }

    deselect(emitEvent = true) {
        emitEvent && this.$emit('deselect');
        this.selected = null;
        this.selectedUserId = null;
        EventBus.$emit('modalClosed');
    }

    destroyed() {
        this.$refs['list'] && ((this.$refs['list'] as any).$el as HTMLElement).removeEventListener('scroll', this.userScrollHandler);
        window.removeEventListener('resize', this.resizeHandler);
        this.dataHelper.clean();
    }

}
